import React, { Component } from "react";

export class HealthCheck extends Component {
  render() {
    return (
      <React.Fragment>
        <div>
          Ok
        </div>
      </React.Fragment>
    );
  }
}

export default HealthCheck;
